/**
 * Strips `//` line comments and `/*`-style block comments from a
 * JSON-with-comments (JSONC) string so it can be retried with `JSON.parse`.
 *
 * Content authors routinely paste structured-data examples from Google's
 * Search Central docs, which embed `//` comments — accepted by Google's Rich
 * Results Test but illegal in strict JSON (EPS-4335). This walker is
 * string-aware: quoted regions are copied verbatim (honoring `\` escapes), so
 * comment markers inside values (`"https://..."`, `"a /* b"`) are never
 * mangled. Line comments keep their trailing newline so line numbers in a
 * subsequent parse error still point at the authored content.
 */
export function stripJsonComments(input: string): string {
  let output = '';
  let i = 0;

  while (i < input.length) {
    const char = input[i];

    if (char === '"') {
      output += char;
      i++;
      while (i < input.length) {
        const stringChar = input[i];
        output += stringChar;
        i++;
        if (stringChar === '\\') {
          if (i < input.length) {
            output += input[i];
            i++;
          }
          continue;
        }
        if (stringChar === '"') break;
      }
      continue;
    }

    if (char === '/' && input[i + 1] === '/') {
      while (i < input.length && input[i] !== '\n') i++;
      continue;
    }

    if (char === '/' && input[i + 1] === '*') {
      i += 2;
      while (i < input.length && !(input[i] === '*' && input[i + 1] === '/')) i++;
      i += 2;
      // A single space keeps neighboring tokens separated where the comment sat.
      output += ' ';
      continue;
    }

    output += char;
    i++;
  }

  return output;
}
